
define('text!modules/creatives/concept/templates/creative_list.html',[],function () { return '<div class="creative-list-list-container"></div>';});

